<script>
  import { link } from '../svelte-navigator';

  export let value;
  export let href = "";
</script>

<a href={href} use:link>{value}</a>